


export function getSnippetIcon(lang: string) {
    if (!lang) {
        return 'text'
    } else if (lang === 'txt' || lang === 'text') {
        return 'text'
    } else if (lang === 'htm') {
        return 'html'
    } else if (lang === 'hpp') {
        return 'cpp'
    } else if (lang === 'json') {
        // No dedicated json.png icon asset exists yet; javascript's is the
        // closest visual match among existing icons.
        return 'javascript'
    } else {
        return lang;
    }
}



export function getFileRefIcon(fName: string) {
    if (!fName || !fName.includes(".")) return "file";

    const ext = fName.split(".").pop()!.toLowerCase();

    if (
        ext === "jpg" ||
        ext === "jpeg" ||
        ext === "png" ||
        ext === "gif" ||
        ext === "webp" ||
        ext === "svg" ||
        ext === "bmp" ||
        ext === "tiff" ||
        ext === "ico"
    ) {
        return "photo-icon.png";
    } else if (
        ext === "obj" ||
        ext === "stl" ||
        ext === "fbx" ||
        ext === "gltf" ||
        ext === "glb" ||
        ext === "dae" ||
        ext === "3ds" ||
        ext === "blend" ||
        ext === "max" ||
        ext === "ma" ||
        ext === "mb" ||
        ext === "c4d" ||
        ext === "usd" ||
        ext === "usda" ||
        ext === "usdc" ||
        ext === "usdz" ||
        ext === "ply" ||
        ext === "x3d" ||
        ext === "wrl" ||
        ext === "vrml" ||
        ext === "step" ||
        ext === "stp" ||
        ext === "iges" ||
        ext === "igs" ||
        ext === "skp" ||
        ext === "3dm" ||
        ext === "dxf" ||
        ext === "dwg" ||
        ext === "sldprt" ||
        ext === "sldasm" ||
        ext === "ipt" ||
        ext === "iam" ||
        ext === "f3d" ||
        ext === "3mf" ||
        ext === "amf"
    ) {
        return "3d.png";
    } else if (
        ext === "mp4" ||
        ext === "mov" ||
        ext === "avi" ||
        ext === "mkv" ||
        ext === "webm" ||
        ext === "wmv" ||
        ext === "flv" ||
        ext === "m4v" ||
        ext === "mpg" ||
        ext === "mpeg" ||
        ext === "3gp" ||
        ext === "3g2" ||
        ext === "ogv" ||
        ext === "m2v" ||
        ext === "mts" ||
        ext === "m2ts" ||
        ext === "ts" ||
        ext === "vob" ||
        ext === "rm" ||
        ext === "rmvb" ||
        ext === "asf" ||
        ext === "divx" ||
        ext === "f4v"
    ) {
        return "vid.png"
    } else if (
        ext === "sb3" ||
        ext === "sb2" ||
        ext === "sb"
    ) {
        return "sb3.png"
    } else if (
        ext === 'pdf'
    ) {
        return "pdf.png"
    } else if (
        ext === "docx" ||
        ext === "doc"
    ) {
        return "docx.png"
    } else if (
        ext === "ppt" ||
        ext === "pptx"
    ) {
        return "ppt.png"
    } else if (
        ext === "xls" ||
        ext === "xlsx" ||
        ext === "xlsm"
    ) {
        return "xls.png"
    } else if (
        ext === "zip" ||
        ext === "rar" ||
        ext === "7z" ||
        ext === "tar" ||
        ext === "gz" ||
        ext === "tgz" ||
        ext === "bz2" ||
        ext === "xz"
    ) {
        return "zip.png"
    } else if (ext === "ai") {
        return "ai.png"
    } else if (ext === "psd" || ext === "ps") {
        return "psd.png"
    } else if (
        ext === 'mp3'
        || ext === 'wav'
        || ext === 'ogg'
        || ext === 'oga'
        || ext === 'm4a'
        || ext === 'aac'
        || ext === 'flac'
        || ext === 'wma'
        || ext === 'aiff'
        || ext === 'aif'
        || ext === 'aifc'
        || ext === 'mid'
        || ext === 'midi'
        || ext === 'opus'
        || ext === 'amr'
        || ext === 'caf'
        || ext === 'au'
        || ext === 'snd'
        || ext === 'alac'
        || ext === 'ape'
        || ext === 'wv'
        || ext === 'tta'
        || ext === 'dsf'
        || ext === 'dff'
        || ext === 'ra'
        || ext === 'ram'
        || ext === 'mka'
        || ext === 'voc'
        || ext === 'xm'
        || ext === 'mod'
        || ext === 's3m'
        || ext === 'it'
    ) {
        return 'sound.png'
    }


    //to do

    //Overall i can't return ext if none of these are true because it won't work on everything
    //I can't account for every single file type that exists
    //I will return a default if none exist but here is a list of ones I should also add to the if statements


    //That means for some that I already had working i will need to account for again

    //microsoft office files

    //Sound / Audio files: mp3, wav, others

    //Scratch and Roblox, vex, possibly unreal or any other common educational tool

    //Adobe Files

    //

    return 'default.png';
}

export function getSnippetExtension(lang: string) {
    if (!lang) return 'txt';

    const normalized = lang.toLowerCase().trim();

    if (normalized === 'txt') return 'txt';
    if (normalized === 'text') return 'txt';
    if (normalized === 'plaintext') return 'txt';

    if (normalized === 'html') return 'html';
    if (normalized === 'htm') return 'htm';

    if (normalized === 'css') return 'css';
    if (normalized === 'less') return 'less';
    if (normalized === 'sass') return 'scss';
    if (normalized === 'scss') return 'scss';

    if (normalized === 'xml') return 'xml';
    if (normalized === 'xaml') return 'xaml';

    if (normalized === 'javascript') return 'js';
    if (normalized === 'js') return 'js';

    if (normalized === 'typescript') return 'ts';
    if (normalized === 'ts') return 'ts';

    if (normalized === 'jsx') return 'jsx';
    if (normalized === 'tsx') return 'tsx';
    if (normalized === 'react') return 'jsx';

    if (normalized === 'python') return 'py';
    if (normalized === 'py') return 'py';

    if (normalized === 'java') return 'java';
    if (normalized === 'kotlin') return 'kt';
    if (normalized === 'kt') return 'kt';

    if (normalized === 'c') return 'c';
    if (normalized === 'h') return 'h';

    if (normalized === 'cpp') return 'cpp';
    if (normalized === 'c++') return 'cpp';
    if (normalized === 'cc') return 'cc';
    if (normalized === 'cxx') return 'cxx';
    if (normalized === 'hpp') return 'hpp';

    if (normalized === 'csharp') return 'cs';
    if (normalized === 'cs') return 'cs';

    if (normalized === 'go') return 'go';
    if (normalized === 'php') return 'php';
    if (normalized === 'ruby') return 'rb';
    if (normalized === 'rb') return 'rb';

    if (normalized === 'rust') return 'rs';
    if (normalized === 'rs') return 'rs';

    if (normalized === 'swift') return 'swift';
    if (normalized === 'lua') return 'lua';
    if (normalized === 'dart') return 'dart';
    if (normalized === 'sql') return 'sql';

    if (normalized === 'arduino') return 'ino';
    if (normalized === 'ino') return 'ino';

    if (normalized === 'csv') return 'csv';

    if (normalized === 'json') return 'json';

    return 'txt';
}


export const BLOCKED_EXTENSIONS = [
    // Windows executables / installers
    ".exe",
    ".msi",
    ".bat",
    ".cmd",
    ".com",
    ".scr",
    ".pif",
    ".cpl",

    // PowerShell / Windows scripting
    ".ps1",
    ".psm1",
    ".psd1",
    ".vbs",
    ".vbe",
    ".jscript",
    ".wsf",
    ".wsh",

    // Mac executables / installers
    ".app",
    ".dmg",
    ".pkg",
    ".command",

    // Linux / Unix executables or packages
    ".sh",
    ".bash",
    ".zsh",
    ".fish",
    ".run",
    ".bin",
    ".deb",
    ".rpm",
    ".appimage",

    // Java / Android executable packages
    ".jar",
    ".war",
    ".ear",
    ".apk",

    // Browser / extension packages
    ".crx",
    ".xpi",

    // Potentially risky shortcut/link files
    ".lnk",
    ".url",
    ".desktop",

    // Registry / system config
    ".reg",
    ".dll",
    ".sys",
    ".drv",

    // Macro-enabled Office files
    ".docm",
    ".xlsm",
    ".pptm",
    ".dotm",
    ".xltm",
    ".potm",

    // Disk images / virtual machine images
    ".iso",
    ".img",
    ".vhd",
    ".vhdx",
    ".ova",
    ".ovf"
] as const;



export function isValidFile(name: string) {
    const cleanName = name.trim();

    const hasNormalExtension = /^[^.\s][^/\\]*\.[^./\\\s]+$/;

    if (!hasNormalExtension.test(cleanName)) {
        return false;
    }

    const lastDot = cleanName.lastIndexOf('.');
    const ext = cleanName.slice(lastDot).trim().toLowerCase();

    if (BLOCKED_EXTENSIONS.some(e => e.toLowerCase() === ext)) {
        return false;
    }

    return true;
}
